import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core'
import { MatIconButton } from '@angular/material/button'
import { MatIcon } from '@angular/material/icon'
import { Router } from '@angular/router'
import { Interval, IsoIntervalStr } from '@elderbyte/ngx-starter'
import { BehaviorSubject } from 'rxjs'

@Component({
  selector: 'app-utilisation-interval-link',
  templateUrl: './utilisation-interval-link.component.html',
  styleUrls: ['./utilisation-interval-link.component.scss'],
  imports: [MatIconButton, MatIcon],
})
export class UtilisationIntervalLinkComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly facility$ = new BehaviorSubject<string>(null)
  public readonly scheduleInterval$ = new BehaviorSubject<Interval>(null)
  private router = inject(Router)

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set facility(facility: string) {
    if (facility) {
      this.facility$.next(facility)
    }
  }

  @Input()
  public set scheduleInterval(interval: Interval | IsoIntervalStr) {
    if (interval) {
      if (!(interval instanceof Interval)) {
        interval = Interval.parse(interval)
      }
      this.scheduleInterval$.next(interval)
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public Api                                                              *
   *                                                                         *
   **************************************************************************/

  public openUtilisationInterval(event: Event): void {
    const interval = this.scheduleInterval$.getValue()
    const facility = this.facility$.getValue()
    this.router.navigate(['app', 'scheduling'], {
      queryParams: {
        interval: interval.toInstantString(),
        facility: facility,
      },
    })
  }

  /***************************************************************************
   *                                                                         *
   * Private Api                                                             *
   *                                                                         *
   **************************************************************************/
}
